import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import { Drawer } from "vaul";
import { DrawerPortal } from "@/components/Drawer";
import { Dialog, DialogContent } from "@/components/Dialog";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
import { useLang } from "@/common/Contexts/LanguageContext";
var CancelReasonsModal = function CancelReasonsModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    reasons = _ref.reasons;
  var isMobile = useIsMobile();
  var lang = useLang();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(""),
    selectedReasonId = _useState[0],
    setSelectedReasonId = _useState[1];
  var _useState2 = useState(""),
    note = _useState2[0],
    setNote = _useState2[1];
  var _useState3 = useState(false),
    showNoteInput = _useState3[0],
    setShowNoteInput = _useState3[1];
  var handleReasonSelect = function handleReasonSelect(reasonId) {
    setSelectedReasonId(reasonId);
    // Show note input if "Others" is selected (id: -1)
    setShowNoteInput(reasonId === "-1");
  };
  var handleSubmit = function handleSubmit() {
    if (!selectedReasonId) return;
    onSubmit(selectedReasonId, note);
    // Reset state
    setSelectedReasonId("");
    setNote("");
    setShowNoteInput(false);
  };

  // Sort reasons to show the one with id -1 at the end
  var sortedReasons = _toConsumableArray(reasons).sort(function (a, b) {
    if (a.cancellation_reason_id === "-1") return 1;
    if (b.cancellation_reason_id === "-1") return -1;
    return 0;
  });
  var content = /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 pt-4"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-xl font-bold text-primary-new py-2"
  }, tShort("modal/cancellation_reason_title", {
    ns: "sell_trade_landing"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, sortedReasons.map(function (reason) {
    return /*#__PURE__*/React.createElement("label", {
      key: reason.cancellation_reason_id,
      className: "flex flex-col gap-3 p-4 border-[1px] border-solid border-[#D6DFE9] rounded-lg cursor-pointer transition-colors ".concat(selectedReasonId === reason.cancellation_reason_id ? "" : "border-gray-200 hover:border-gray-300")
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3"
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "cancellation_reason",
      value: reason.cancellation_reason_id,
      checked: selectedReasonId === reason.cancellation_reason_id,
      onChange: function onChange() {
        return handleReasonSelect(reason.cancellation_reason_id);
      },
      className: "w-5 h-5 text-[#8E47E0] focus:ring-[#8E47E0]"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-base text-gray-900"
    }, lang === "ar" ? reason.cancellation_reason_name_arabic : reason.cancellation_reason_name_english)), reason.cancellation_reason_id === "-1" && showNoteInput && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-2 mt-2"
    }, /*#__PURE__*/React.createElement("textarea", {
      value: note,
      onChange: function onChange(e) {
        return setNote(e.target.value);
      },
      placeholder: tShort("modal/additional_notes_placeholder", {
        ns: "sell_trade_landing"
      }),
      className: "w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-new focus:border-transparent resize-none",
      rows: 1,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    })));
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleSubmit,
    disabled: !selectedReasonId || showNoteInput && !note.trim(),
    className: "outline-none border-none w-full md:w-[70%] md:mx-auto py-3 px-4 bg-primary-new text-white font-semibold rounded-lg hover:bg-[#7A3BC7] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
  }, tShort("modal/send_button", {
    ns: "sell_trade_landing"
  })));
  return /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Drawer.Root, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    },
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DrawerPortal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-[#071425] opacity-80 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "bg-white flex flex-col rounded-t-[10px] fixed bottom-0 left-0 right-0 z-[9999] py-4 px-6"
  }, content)))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "min-w-[570px] p-6",
    haveClose: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute en:left-[unset] left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F] cursor-pointer"
  })), content))));
};
export default CancelReasonsModal;